import { CircularProgress, Stack } from "@mui/material";
import { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { ColorModeProvider } from "./contexts/ColorModeContext";
import "./i18n/config";
import { LandingPage } from "./pages/LandingPage";
import { NotFoundPage } from "./pages/NotFoundPage";

function AppFallback() {
  return (
    <Stack alignItems="center" justifyContent="center" sx={{ height: "100vh" }}>
      <CircularProgress color="primary" />
    </Stack>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <ColorModeProvider>
        <Suspense fallback={<AppFallback />}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </BrowserRouter>
        </Suspense>
      </ColorModeProvider>
    </HelmetProvider>
  );
}
